module.exports = __webpack_public_path__ + "static/media/Fam.f60f9329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/Fam.jpg
// module id = 653
// module chunks = 0